import humps from 'humps';

export const camelizeKeys = (object) => {
  return humps.camelizeKeys(object);
};
